import { CartFragment } from '../../graphql/magento'
import { conversionsEventItemsFromCartItems } from './cart'
import { setConversionsEventMeta } from './state'

const isGpcEnabled = typeof navigator !== 'undefined' && !!navigator.globalPrivacyControl

export const getPrivacyControlOptions = ():
  | {
      data_processing_options: ['LDU']
      data_processing_options_country: 0
      data_processing_options_state: 0
    }
  | Record<string, never> =>
  isGpcEnabled
    ? {
        data_processing_options: ['LDU'],
        data_processing_options_country: 0,
        data_processing_options_state: 0,
      }
    : {}

// track cart ids for which InitiateCheckout has already been sent in this session
// (the analytics observable handles the same dedup for the GA `begin_checkout` event)
const sentBeginCheckoutCartIds = new Set<string>()

export const publishConversionsBeginCheckout = (cart: CartFragment): void => {
  const currency = cart.prices?.grand_total?.currency
  const totalValue = cart.prices?.grand_total?.value
  if (currency == null || totalValue == null) {
    return
  }
  if (sentBeginCheckoutCartIds.has(cart.id)) {
    return
  }
  sentBeginCheckoutCartIds.add(cart.id)

  setConversionsEventMeta({
    event_name: 'InitiateCheckout',
    custom_data: {
      content_type: 'product',
      contents: conversionsEventItemsFromCartItems(cart.items ?? []),
      currency,
      value: totalValue,
    },
    ...getPrivacyControlOptions(),
  })
}
